export default "__VITE_ASSET__BzB4WYCq__"